import { HTMLAttributes } from "react";
import './index.scss'

const Image = (
    prop: {
        src: string,
        mode?: "aspectFill",
    } & HTMLAttributes<HTMLDivElement>
) => {
    return <div
        {...prop}
        className={`img-wrapper ${prop.className || ''}`}
    >
        <img draggable={false} src={prop.src} />
    </div>
}

export default Image;